import { IDatasourceSQLMap } from 'src/app/utils/datasource-sql-map/datasource';

export class BiCoreProjectSessionsSqlMap {
    public static sqlMap: IDatasourceSQLMap = {
        dataset: 'bi_core',
        tableId: 'project_sessions',
        columns: {},
    };
}
